<div class="container-fluid">
  <form class="row">
    <div class="col-md-12 px-0">
      <div class="section-padding">
        <div class="text-right close-section">
          <img
            src="/assets/icons/close-sheet.svg"
            class="my-2"
            (click)="closeBottomSheet()"
            alt="close"
          />
        </div>

        <section class="form-group">
          <h4 class="title-text mb-4 f-14">Select payment method</h4>

          <div class="payment-plan mb-4">
            <button
              type="button"
              class="payment-plan__option"
              [ngClass]="{ 'payment-plan__option--active': selectedPaymentPlan === 'full' }"
              (click)="selectPaymentPlan('full')"
            >
              <span class="plan-radio">
                <span class="plan-radio__dot"></span>
              </span>
              <span class="plan-label">Full payment</span>
            </button>

            <button
              type="button"
              class="payment-plan__option"
              [ngClass]="{ 'payment-plan__option--active': selectedPaymentPlan === 'split' }"
              (click)="selectPaymentPlan('split')"
            >
              <span class="plan-radio">
                <span class="plan-radio__dot"></span>
              </span>
              <span class="plan-label">Split payment</span>
            
            </button>
          </div>

          <div class="total-row mb-4">
            <span class="f-14 text-[#344054] fw-400">Total to pay</span>
            <span class="f-16 text-[#1D2939] fw-600">{{ totalToPay | currency : '₦' }}</span>
          </div>

          <label for="payment-method" class="f-14 primary-font-medium label-text">
            Select payment channel
          </label>

          <div *ngFor="let method of paymentMethods; last as isLast">
            <article
              *ngIf="method.show !== false"
              class="d-flex flex-row gap-2 align-items-center payment-method"
              [ngClass]="{
                'mb-3': !isLast,
                'selected-method': isMethodSelected(method)
              }"
              (click)="selectMethod(method)"
            >
              <img
                class="selected-icon"
                src="/assets/icons/selection-indicator.svg"
                alt=""
                *ngIf="isMethodSelected(method)"
              />
              <div>
                <img [src]="method?.icon" alt="" />
              </div>
              <div class="d-flex flex-column">
                <p class="primary-font-normal mb-0 text-gray-700">
                  {{ method?.label }}
                </p>
                <p class="f-14 mb-0 primary-font-normal text-gray-500">
                  {{ method?.description }}
                </p>
                <div
                  class="split-input mt-3"
                  *ngIf="selectedPaymentPlan === 'split' && isMethodSelected(method)"
                >
                  <input
                    *ngIf="isFirstSplitMethod(method)"
                    #firstSplitAmountInput
                    type="number"
                    min="0"
                    [max]="totalToPay"
                    [value]="firstSplitAmount"
                    (click)="$event.stopPropagation()"
                    (input)="updateFirstSplitAmount(firstSplitAmountInput.value)"
                    placeholder="Enter amount"
                  />
                  <input
                    *ngIf="isSecondSplitMethod(method)"
                    type="number"
                    [value]="secondSplitAmount"
                    readonly
                    (click)="$event.stopPropagation()"
                  />
                </div>
              </div>
            </article>
          </div>

          <div class="py-3">
            <button
              type="button"
              (click)="proceedToCheckout()"
              [disabled]="!canProceed"
              class="btn py-2 btn-dark btn-block f-14 primary-font-normal"
            >
              {{ btnText }}
            </button>
          </div>
        </section>
      </div>
    </div>
  </form>
</div>
